import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  printMode = new Subject<boolean>();
  printing = new BehaviorSubject<boolean>(false);

  print() {
    this.printMode.next(true);
    setTimeout(async () => {
      await new Promise((resolve, reject) => {
        window.focus();
        window.print();
        // window.close();
        resolve(true);
      });
      this.printMode.next(false);
    }, 500);
  }
}
